import React from 'react';
import { Attachment } from 'presentation/components/Queue/Chat/Chat';
import MessageAttachments from '../MessageAttachments/MessageAttachments';
import MobileMessageAttachments from 'presentation/components/Mobile/MobileAttachments/MobileMessageAttachments';

type ResponsiveAttachmentsProps = {
  attachments: Attachment[];
  isMobile?: boolean;
};

/**
 * A component that renders either the desktop or mobile version of the attachments component
 * based on the isMobile prop
 */
const ResponsiveAttachments: React.FC<ResponsiveAttachmentsProps> = ({ attachments, isMobile = false }) => {
  if (!attachments || attachments.length === 0) {
    return null;
  }

  return isMobile ? (
    <MobileMessageAttachments attachments={attachments} />
  ) : (
    <MessageAttachments attachments={attachments} />
  );
};

export default ResponsiveAttachments;
